export const packageAdd = (data) => {
    return {
        type: 'PACKAGE',
        data,
    }
}
